import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const MarketSegmentRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/market-segments'),
});